export const extractFileExtension = (fullFileName) => {
    const regex = /(?:\.([^.]+))?$/;
    return regex.exec(fullFileName)?.[1]?.toLowerCase() ?? '';
};
export const capitalizeFirstLetter = (input) => {
    return !input ? '' : input.charAt(0).toUpperCase() + input.slice(1);
};
export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    }
    catch {
        return false;
    }
    return true;
};
//# sourceMappingURL=string.utils.js.map